import React from "react";
import FooterSection from "./FooterSection";

function Footer() {
  return (
    <>
      <FooterSection />
    </>
  );
}

export default Footer;
